// Wormhole Connection Data
// Each connection is a pair of star system IDs [fromId, toId]
export const WORMHOLE_DATA = [
  [0, 1],
  [0, 4],
  [0, 7],
  [0, 9],
  [0, 11],
  [0, 12],
  [0, 16],
  [0, 19],
  [1, 13],
  [4, 23],
  [4, 73],
  [5, 6],
  [5, 7],
  [5, 27],
  [5, 65],
  [7, 34],
  [7, 36],
  [9, 13],
  [9, 14],
  [9, 31],
  [9, 33],
  [11, 1],
  [11, 39],
  [11, 45],
  [13, 35],
  [14, 48],
  [15, 1],
  [15, 42],
  [15, 46],
  [16, 57],
  [21, 25],
  [21, 58],
  [23, 53],
  [23, 91],
  [25, 40],
  [25, 72],
  [27, 34],
  [27, 65],
  [28, 37],
  [28, 54],
  [28, 66],
  [31, 13],
  [31, 56],
  [32, 36],
  [32, 64],
  [32, 67],
  [35, 92],
  [37, 68],
  [37, 103],
  [40, 81],
  [46, 52],
  [46, 82],
  [49, 56],
  [50, 35],
  [51, 1],
  [51, 55],
  [52, 76],
  [53, 63],
  [55, 105],
  [57, 78],
  [61, 85],
  [61, 87],
  [63, 1],
  [68, 109],
  [69, 90],
  [73, 75],
  [80, 89],
  [83, 94],
  [84, 88],
  [98, 99],
];
